export default {
    title: 'ABOUT ME',
    me: 'I’m Roman Baďurík, developer living in Slovakia, Europe. I graduated from the Slovak University of Technology with masters degree and I have more than 10 years’ experience as programmer and developer. <br/>I’m looking for new challenges and opportunities and I’m interested in the latest technologies. <br/><strong>Effective and high quality code processing is my priority.</strong> At a present time I programme in vue.js, typescript, html5, scss, boostrap, node.js, MongoDB.',
    contact: 'In case of any questions do not hesitate to conact me: <strong><a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a></strong>',
    version: 'This is a STARTUP project on first Version: 1.0, copyright 2021 Roman Baďurík',
    dataPolicy: {
        title: 'Data policy',
        text: 'Your formatted data is\'nt processed and any way stored.'
    },
    privacyPolicy: {
        title: 'Privacy policy',
        text: 'Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computers hard drive.<br/> JSON Formatter websites specifically uses them to enhance user experiences by remembering preferences. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.'
    },
    reportBug: {
        title: 'Report a bug',
        text: 'If you encounter a bug or have questions or suggestions for improvements, please report this at <a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a>'
    },
    advertising: {
        title: 'Advertising',
        text: 'For any advertising inquiries please contact <a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a>.'
    }
}
